import React, { useMemo } from "react";
import GenericListPage from "../../pages/GenericListPage";

const BusinessAdminTransactionsPage = () => {
  const columns = useMemo(() => [
    { header: "Date", key: "createdAt", render: (item) => new Date(item.createdAt).toLocaleString() },
    { header: "User", key: "customer_name" },
    { header: "Email", key: "customer_email" },
    { header: "Amount", key: "amount", render: (item) => `${item.amount} ${item.currency || "USD"}` },
    { header: "Status", key: "status" },
    { header: "Transaction ID", key: "transactionId" },
    { header: "Organization", key: "organizationName" },
  ], []);

  return (
    <GenericListPage
      title="All Transactions"
      entityEndpoint="business-admin/subscription-transactions"
      columns={columns}
      hideActions={true}
      filterConfig={[
        { label: "Email", name: "userEmail", type: "text", placeholder: "User Email" },
        { label: "Status", name: "status", type: "select", options: [
          { label: "All", value: "" },
          { label: "Success", value: "success" },
          { label: "Pending", value: "pending" },
          { label: "Failed", value: "failed" },
        ]},
      ]}
    />
  );
};

export default BusinessAdminTransactionsPage;